export default function Education(){
    return (
        <section id="education" className="education">
            <h1>EDUCATION</h1> 
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="timeline">
                            <div className="item">
                                <h3>MCA<span>2021-2023</span></h3>
                                <h4>Bharathidasan University</h4>
                                <p>Annai College of Arts & Science | CGPA - 7.84</p>
                            </div>
                            <div className="item">
                                <h3>BCA<span>2018-2021</span></h3>
                                <h4>Bharathidasan University</h4>
                                <p>Annai College of Arts & Science | CGPA - 7.43</p>
                            </div>
                            <div className="item">
                                <h3>HSC<span>2017-2018</span></h3>
                                <h4>State Board of Tamil Nadu</h4>
                                <p>N.Kittappa Mpl. Hr. Sec. School | Percentage - 63.33</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div><br/>
        </section>
    );
}